import { render, staticRenderFns } from "./GuaranteeLegalMentions.vue?vue&type=template&id=2c373e97"
import script from "./GuaranteeLegalMentions.vue?vue&type=script&lang=js"
export * from "./GuaranteeLegalMentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports